<!--
	TEMPLATE
-->
<template>
	<div class="md-grey-page">
		<div class="edit-page container margin-top-60" v-if="!propertyLoaded">
			<p class="loading-text">Loading property<span>.</span><span>.</span><span>.</span></p>
		</div>

		<div class="edit-page container" v-if="propertyLoaded">
		  <div class="mdc-layout-grid">
				<div class="mdc-layout-grid__inner edit-page__inner">
					<transition appear appear-class="fade-enter" appear-active-class="fade-enter-active">
				  	<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">

						  <div class="edit-page__header edit-page__info mdc-layout-grid__cell--span-3">
								<div class="edit-page__image center-vertical-wrapper" v-if="!scroll">
									<!-- <div class="edit-page__slider-icon align-bottom-right">
										<i class="ico-search" @click.prevent="showSlider()"></i>
									</div> -->
									<google-map class="section-map mq-md-hidden" v-bind:lat="property.address.latitude" v-bind:lng="property.address.longitude" v-if="address.street.length > 0 && address.postcode.length > 0"></google-map>
								</div>

								<div class="edit-page__overlay mq-md-show"></div>
									<h3 class="edit-page__title">{{ propertyAddress(property) }}<br>{{ propertyBedsAndPrice(property) }}</h3>
								<div class="edit-page__back-btn mq-md-show"><a href="/#/properties"><i class="ico-arrow"></i></a></div>

								<!-- Portals -->
								<portals-status-box v-model="portalProperty" :updatingPortals="updatingPortals" class=" mdc-layout-grid__cell--span-3" v-if="portalProperty && portalProperty.length" v-show="!responsive && !property.archived && property.status != 'let' && property.status != 'sold' && property.status != 'withdrawn' && property.status.toLowerCase() != 'appraisal'"></portals-status-box>

								<!-- Social Share -->
								<social-share id="social-share-property-desktop" v-if="socialPortal.liveUrl && socialPortal.liveUrl != ''" :text="tweetText" :link="socialPortal.liveUrl" v-show="!responsive"></social-share>
						  </div>
					</div>
					</transition>

					<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
					<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">

            <!--
              EDIT OWNER
              <editable-item
                v-if="property.ownerId"
                component="editable-options"
                v-model="property.ownerId"
                title="Owner"
                :options="{items: reOwners}"
                @isEditView="editView(arguments[0])"
                @update="updateProperty"
                @back="getProperty"
                @hasErrors="errors('owner', arguments[0])">
              </editable-item>

            -->
						<!-- Social Share -->
						<social-share id="social-share-property-mobile" v-if="socialPortal.liveUrl && socialPortal.liveUrl != ''" :text="tweetText" :link="socialPortal.liveUrl" v-show="responsive"></social-share>

						<!-- Portals -->
						<portals-status-box v-model="portalProperty" :updatingPortals="updatingPortals" class="mdc-layout-grid__cell--span-3" v-if="portalProperty && portalProperty.length" v-show="responsive && !property.archived && property.status != 'let' && property.status != 'sold' && property.status != 'withdrawn' && property.status.toLowerCase() != 'appraisal'" ></portals-status-box >

						<slider v-model="property.images" v-if="mainImage !== ''"></slider>

            <!-- Has owner -->

						<div class="editable-item mdc-layout-grid__inner" v-if="property.ownerId && reOwnersObj[property.ownerId]">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
                <div class="editable-item__centered"><span>Owner</span></div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone editable-item__middle-cell">
                <div class="editable-input editable-item__centered editable-item__content">
                  <div><a href="javascript:;" @click.prevent="$router.push('/owners/'+property.ownerId)">{{ reOwnersObj[property.ownerId] }}</a></div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12"><hr></div>
            </div>
            <div v-else>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
                <div class="editable-item__centered"><span>Owner</span></div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone editable-item__middle-cell">
                <div class="editable-input editable-item__centered editable-item__content">
                  <div><a href="javascript:;" @click.prevent="$router.push('/registerowner/'+property.companyId+'/p/'+property.propertyId)">Add Owner Details</a></div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12"><hr></div>
            </div>
						<!--
            <div class="editable-item mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
                <div class="editable-item__centered"><span>Owner</span></div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone editable-item__middle-cell">
                <div class="editable-input editable-item__centered editable-item__content">
                  <div>

	                    <auto-complete
	                      :exists="((property.ownerId && reOwnersObj[property.ownerId]) ? { id: property.ownerId, name: reOwnersObj[property.ownerId] } : {})"
	                      :options="acOwners"
	                      :newUrl="'/registerowner/'+property.companyId+'/p/'+property.propertyId"
	                      :newTxt="'Add Owner Details'"
	                      :isEditView="false">
	                    </auto-complete>
                  </div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12"><hr></div>
            </div>
					-->

						<!-- Portals List -->
						<editable-item v-if="proPortalsPerProperty" component="editable-checkboxes" v-model="portalsSelection" title="Portals" :options="{items: portalsList, cols: 1}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('address', arguments[0])"></editable-item>

					<!-- Address -->
					<editable-item component="editable-address" v-model="address" title="Address" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('address', arguments[0])"></editable-item>

					<!-- Service type -->
					<editable-item component="editable-options" v-model="property.serviceType" title="Service Type" :options="{items: serviceTypes.map(function(obj) {return [obj.id, obj.name];})}"
					@isEditView="editView(arguments[0])" @update="updateProperty" @changed="changeServiceType()" @back="getProperty"></editable-item>

						<!-- Status -->
						<editable-item
							component="editable-options"
							v-model="property.status"
							title="Status"
							:options="{items: propertyStatusArray}"
							@isEditView="editView(arguments[0])"
							@update="updateProperty"
							@back="getProperty"
							@hasErrors="errors('status', arguments[0])">
						</editable-item>

						<!-- Price -->
						<editable-item component="editable-price" v-model="priceObj" title="Price"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" :options="{serviceTypeId: property.serviceType}" @hasErrors="errors('price', arguments[0])"></editable-item>

						<!-- Price term -->
						<editable-item component="editable-options" v-model="property.priceTerms" title="Price Term" :options="{items: priceTermsArray, large: true}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('price-term', arguments[0])"></editable-item>

						<!-- Property type -->
						<editable-item component="editable-options" v-model="property.type" title="Property Type" :options="{items: propertyTypes.map(function(obj) {return [obj.id, obj.name];})}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('type', arguments[0])"></editable-item>

						<!-- Property Subtype -->
						<editable-item
							component="editable-options"
							v-model="property.subtype"
							title="Property Subtype"
							:options="{items: propertySubtypesArray}"
							@isEditView="editView(arguments[0])"
							@update="updateProperty"
							@back="getProperty"
							 @hasErrors="errors('subtype', arguments[0])">
						</editable-item>

						<!-- Bedrooms -->
						<editable-item component="editable-rooms" v-model="property.bedrooms" title="Bedrooms" :options="{items: bedrooms.map(function(obj) {return [obj.bedrooms, obj.name];})}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('bedrooms', arguments[0])"></editable-item>

						<!-- Livingrooms -->
						<editable-item component="editable-rooms" v-model="property.livingrooms" title="Reception rooms" :options="{items: livingrooms.map(function(obj) {return [obj.livingrooms, obj.name];})}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('livingrooms', arguments[0])"></editable-item>

						<!-- Bathrooms -->
						<editable-item component="editable-rooms" v-model="property.bathrooms" title="Bathrooms" :options="{items: bathrooms.map(function(obj) {return [obj.bathrooms, obj.name];})}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('bathrooms', arguments[0])"></editable-item>

						<!-- Furnishing status -->
						<editable-item
							v-show="property.serviceType === serviceType.LETTINGS"
							component="editable-options"
							v-model="property.furnishingStatus"
							title="Furnishing Status"
							:options="{items: furnishingStatusArray, large: true}"
							@isEditView="editView(arguments[0])"
							@update="updateProperty"
							@back="getProperty"
							 @hasErrors="errors('furnishing', arguments[0])">
						</editable-item>

						<editable-item
							v-show="property.serviceType !== serviceType.LETTINGS"
							component="editable-options"
							v-model="property.tenure"
							title="Tenure Status"
							:options="{items: [['freehold', 'Freehold'],['leasehold', 'Leasehold'],['freehold-share', 'Share of freehold']], large: true}"
							@isEditView="editView(arguments[0])"
							@update="updateProperty"
							@back="getProperty"
							 @hasErrors="errors('tenure', arguments[0])">
						</editable-item>

						<!-- Features -->
						<editable-item  v-model="property.features" component="editable-features" title="Features"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty"  @hasErrors="errors('features', arguments[0])"></editable-item>

						<!-- Photos -->
						<editable-item component="editable-photos" v-model="property.images" title="Photos" @isEditView="editView(arguments[0])"
						@update="updateProperty" @back="getProperty"></editable-item>

						<!-- VirtualTours -->
						<editable-item component="editable-input" v-model="property.virtualtour" title="Virtual Tour" :options="{placeholder: 'Copy & paste your virtual tour URL here'}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('virtualtour', arguments[0])"></editable-item>


						<!-- Floorplans -->
						<editable-item component="editable-photos" :options="{itemLabel: 'floorplan'}" v-model="property.floorplans" title="Floor Plans" @isEditView="editView(arguments[0])"
						@update="updateProperty" @back="getProperty"></editable-item>

						<!-- EPC -->
						<editable-item component="editable-epc" v-model="property.epc" title="EPC" @isEditView="editView(arguments[0])"
						@update="updateProperty" @back="getProperty"></editable-item>

						<!-- EPC Letter-->
						<editable-item v-show="property.brochure !== ''" component="editable-options" v-model="property.epcLetter" title="Epc Letter" :options="{items: epcLetter.map(function(obj) {return [obj.letter, obj.name];})}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('epcLetter', arguments[0])"></editable-item>

						<!-- BROCHURE -->
						<editable-item component="editable-brochure" v-model="property.brochure" title="Brochure" @isEditView="editView(arguments[0])"
						@update="updateBrochure" @back="getProperty"></editable-item>

						<!-- Short Description -->
						<editable-item component="editable-text" v-model="property.shortDescription" title="Short Description" :options="{rows: 6, limit: 250}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('short', arguments[0])"></editable-item>

						<!-- Long Description -->
						<editable-item component="editable-text" v-model="property.longDescription" title="Long Description" :options="{rows: 10}"
						@isEditView="editView(arguments[0])" @update="updateProperty" @back="getProperty" @hasErrors="errors('long', arguments[0])"></editable-item>

						<!-- Delete and Archive this property -->
						<div class="editable-item mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 editable-item__title">
								<a href="#" class="edit-page__archive" v-if="!property.archived" @click.prevent="archiveProperty"><i class="ico ico-archive "></i>Archive this property</a>
								<a href="#" class="edit-page__archive" v-else @click.prevent="archiveProperty"><i class="ico ico-archive ico-archive--not"></i>Unarchive this property</a>
							</div>
							<br>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 editable-item__title">
								<a href="#" class="edit-page__delete message--error" @click.prevent="deleteProperty"><i class="ico ico-trash"></i>Delete this property</a>
							</div>
						</div>

					</div>
					</transition>
				</div>
			</div>

			<!-- Photos Slideshow -->
				<!-- <slider id="slider-modal" v-model="property.images"></slider> -->
		</div>

		<!-- Add Property Button -->
		<figure class="btn-add-property--fixed">
			<button class="mdc-fab material-icons mdc-ripple-upgraded" type="button" aria-label="addProperty" @click.prevent="$router.push('/properties/add')"><i class="ico ico-plus_math mdc-fab__icon"></i></button>
		</figure>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import EditableItem 	from '../components/editable-items/EditableItem.vue';
import PortalsStatusBox 	from '../components/PortalsStatusBox.vue';
import Slider from '../components/Slider.vue';
import GoogleMap          from '../components/GoogleMap.vue';
import SocialShare from '../components/SocialShare.vue';
import EditableAutocomplete 	from '../components/editable-items/EditableAutocomplete.vue';

export default {
	data: function() {
		return {
			propertyLoaded: false,
			property: {},
			address: {
				number: '',
				flatNumber: '',
				street: '',
				postcode: '',
				town: '',
				county: '',
				lat: 0,
				lng: 0,
				addressNotEmpty: true
			},
			priceObj: {
				price: 0,
				rentFrequency: 'PCM',
				newPrice: 0
			},
			bedrooms: [
				{bedrooms: 0, name: 'Studio'},
				{bedrooms: 1, name: '1 bedroom'},
				{bedrooms: 2, name: '2 bedrooms'},
				{bedrooms: 3, name: '3 bedrooms'},
				{bedrooms: 4, name: '4 bedrooms'},
				{bedrooms: 5, name: '5 bedrooms'},
				{bedrooms: 6, name: '6 bedrooms'},
				{bedrooms: 7, name: '7 bedrooms'},
				{bedrooms: 8, name: '8 bedrooms'},
				{bedrooms: 9, name: '9 bedrooms'},
				{bedrooms: 10, name: '10 bedrooms'},
				{bedrooms: 11, name: '10+ bedrooms'}
			],
			livingrooms: [
				{livingrooms: 0, name: 'No reception room'},
				{livingrooms: 1, name: '1 reception room'},
				{livingrooms: 2, name: '2 reception rooms'},
				{livingrooms: 3, name: '3 reception rooms'},
				{livingrooms: 4, name: '4 reception rooms'},
				{livingrooms: 5, name: '5 reception rooms'},
				{livingrooms: 6, name: '6 reception rooms'},
				{livingrooms: 7, name: '7 reception rooms'},
				{livingrooms: 8, name: '8 reception rooms'},
				{livingrooms: 9, name: '9 reception rooms'},
				{livingrooms: 10, name: '10 reception rooms'},
				{livingrooms: 11, name: '10+ reception rooms'}
			],
			bathrooms: [
				{bathrooms: 0, name: 'No bathroom'},
				{bathrooms: 1, name: '1 bathroom'},
				{bathrooms: 2, name: '2 bathrooms'},
				{bathrooms: 3, name: '3 bathrooms'},
				{bathrooms: 4, name: '4 bathrooms'},
				{bathrooms: 5, name: '5 bathrooms'},
				{bathrooms: 6, name: '6 bathrooms'},
				{bathrooms: 7, name: '7 bathrooms'},
				{bathrooms: 8, name: '8 bathrooms'},
				{bathrooms: 9, name: '9 bathrooms'},
				{bathrooms: 10, name: '10 bathrooms'},
				{bathrooms: 11, name: '10+ bathrooms'}
			],
			epcLetter: [
				{letter: 'a', name: 'A'},
				{letter: 'b', name: 'B'},
				{letter: 'c', name: 'C'},
				{letter: 'd', name: 'D'},
				{letter: 'e', name: 'E'},
				{letter: 'f', name: 'F'},
				{letter: 'g', name: 'G'}
			],
			propertyTypes: [{id: 'house', name: 'House'}, {id: 'flat', name: 'Flat'}],
			serviceTypes: [{id: 'sales', name: 'Sales'}, {id: 'lettings', name: 'Lettings'}],
			serviceType: {
				SALES: 'sales',
				LETTINGS: 'lettings'
			},
			isSlider: false,
			previousServiceTypeId: '',
			allErrors: {},
			tweet: '',
			scroll: false,
			windowWidth: 0,
			windowHeight: 0,
			responsive: false,
			portalProperty: {},
			updatingPortals: false,
			portals: [],
			hasPortalsLive: false,
			portalsList: [],
			portalsSelection: [],
      owners: [],
      acOwners: [],
      reOwners: [],
      reOwnersObj: {}
		}
	},
	components: {
		'editable-item': EditableItem,
    'auto-complete': EditableAutocomplete,
		'portals-status-box': PortalsStatusBox,
		'slider': Slider,
		'google-map': GoogleMap,
		'social-share': SocialShare
	},
	mixins: [utils],
	mounted: function() {
		this.$nextTick(function() {
			window.addEventListener('resize', this.getWindowWidth);
			window.addEventListener('resize', this.getWindowHeight);

			//Init
			this.getWindowWidth()
			this.getWindowHeight()
		});
	},
	created: async function() {
		if(this.proPortalsPerProperty) {
			let portals, portalsCustom, baWebsite;

			try {
				[portals, portalsCustom, baWebsite] = await Promise.all([
					api({endpoint: this.config.services.portals, method: 'GET'}),
					api({endpoint: this.config.services.portalsCustom, method: 'GET'}),
					api({endpoint: this.config.services.website, path: '/get-site', method: 'GET'})
				]);
				portals.map((portal) => {
					if(portal.portalId === 'rm' && portal.live) {
						this.portalsList.push([
							portal.portalId,
							'Rightmove'
						])
					}
          if(portal.portalId === 'zoopla' && portal.live) {
						this.portalsList.push([
							portal.portalId,
							'Zoopla'
						])
					}
          if(portal.portalId === 'otm' && portal.live) {
						this.portalsList.push([
							portal.portalId,
							'On The Market'
						])
					}
				});

				portalsCustom.map((portal) => {
					if(portal.active) {
						this.portalsList.push([
							portal.portalId,
							portal.portal_name+" (Custom Portal)"
						]);
					}
				});

				if(baWebsite.response.Item){
					this.portalsList.push([
						'baWebsite',
						'BestAgent Website'
					]);
				}

			} catch(err) {
				throw {
					type: 'get-all-portals',
					error: err
				}
			}
		}
		// Get Property
    await this.getOwners();
		await this.getProperty();
		await this.getPortals();
		this.getPropertyPortals();
		document.addEventListener('scroll', this.handleScroll);
	},
	destroyed: function () {
		document.removeEventListener('scroll', this.handleScroll);
	},
	computed: {
		propertySubtypes: function() {
			return this.$store.state.propertyLists.propertyTypes[this.property.type];
		},
		propertySubtypesArray: function() {
			const types = this.propertySubtypes;
			if(types) {
				return Object.keys(types).map((key) => {
					return [key, types[key]];
				})
			} else {
				return [];
			}
		},
		propertyStatusArray: function() {
			let statuses = this.$store.state.propertyLists.propertyStatus[this.property.serviceType];
      // Temporary quick&dirty fix, remove later
      statuses['appraisal'] = 'Appraisal';
      if (!statuses['withdrawn'])
        statuses['withdrawn'] = 'Withdrawn';
      if (statuses['Appraisal'])
        delete statuses['Appraisal'];
			return Object.keys(statuses).map((key) => {
				return [key, statuses[key]];
			})
		},
		furnishingStatusArray: function() {
			const statuses = this.$store.state.propertyLists.furnishingStatus;
			return Object.keys(statuses).map((key) => {
				return [key, statuses[key]];
			})
		},
		priceTermsArray: function() {
			const terms = this.$store.state.propertyLists.priceTerms;
			return Object.keys(terms).map((key) => {
				return [key, terms[key]];
			})
		},
		mainImage: function() {
			return this.property.mainImage === null || this.property.mainImage === undefined ? '' : this.property.mainImage
		},
		tweetText: function() {
			var company = this.$store.getters.companyName;
			var text =  company + ' are delighted to bring this ';

			if(this.property.bedrooms == 0) {
				text += 'Studio';
			} else {
				text += this.property.bedrooms + ' bedroom ' + this.propertyTypeName(this.property.type).toLowerCase();
			}
			text += ' to the market priced at ' + this.formatCurrency(this.property.price);
			if(this.property.serviceType == this.serviceType.LETTINGS) {
				text += this.property.rentFrequency;
			}
			text += ' via @bestagentclub';

			return text.replace(/ (limited|ltd)+/gi, '');
		},
		rmPortal: function() {
			const portal = (this.portalProperty && this.portalProperty.length) ? this.portalProperty.filter(portal => (portal.portalId === "rm")) : [];
			return portal.length > 0 ? portal[0] : {};
		},
		zooplaPortal: function() {
			const portal = (this.portalProperty && this.portalProperty.length)  ? this.portalProperty.filter(portal => (portal.portalId === "zoopla")) : [];
			return portal.length > 0 ? portal[0] : {};
		},
		socialPortal: function() {
			if(this.rmPortal.liveUrl) {
				return this.rmPortal;
			}
			if(this.zooplaPortal.liveUrl) {
				return this.zooplaPortal;
			}
			return this.rmPortal;
		},
		proPortalsPerProperty: function() {
 		  return this.$store.getters.subscriptions ? this.$store.getters.subscriptions.indexOf('portal-selector') > -1 : false;
 	  	}
	},
	methods: {
		getWindowWidth: function(event) {
			this.windowWidth = document.documentElement.clientWidth;

			if(this.windowWidth < 839){
				this.responsive = true;
			}else{
				this.responsive = false;
			}
		},

		getWindowHeight: function(event) {
			this.windowHeight = document.documentElement.clientHeight;
		},
		changeServiceType: function() {
			this.priceObj.price = 0;
			this.property.status = '';
			if(this.property.serviceType == this.serviceType.LETTINGS) {
				this.property.furnishingStatus = '';
			}
		},
    getOwners: async function() {
      const rethis = this;
      this.owners = await api({endpoint: this.config.services.owners, path: '/', method: 'GET'});
      this.acOwners = [];
      this.reOwners = [];
      this.reOwnersObj = {};
      await Promise.all(this.owners.map(o => {
        rethis.acOwners.push({id: o.ownerId,name: o.fullName});
        rethis.reOwners.push([o.ownerId, o.fullName]);
        rethis.reOwnersObj[o.ownerId] = o.fullName;
      }));
    },
		getPortals: async function() {
			this.portals = await api({endpoint: this.config.services.portals, method: 'GET'});
			for(let i = 0; i < this.portals.length; i++) {
				if(this.portals[i].active && this.portals[i].live) {
					this.hasPortalsLive = true;
					break;
				}
			}
		},
		getProperty: async function() {
			this.property = await api({endpoint: this.config.services.properties, path: '/' + this.$route.params.id, method: 'GET'});

			// check archive
			if(!this.property.hasOwnProperty("archived")) {
				this.property.archived = false;
			}

			// Address
			this.address = this.property.address;
			if(!this.address.buildingNumber) {
				this.address.buildingNumber = '';
			}
			this.address.addressNotEmpty = true;

			// Price obj
			this.priceObj.price = this.property.price;
			this.priceObj.rentFrequency = this.property.rentFrequency;
			this.priceObj.newPrice = this.property.price;

			// Previous service type ID
			this.previousServiceTypeID = this.property.serviceType;

			const that = this;
			if(!this.property.portalsExclusion) {
				this.property.portalsExclusion = [];
			}

			this.portalsSelection = [];
			this.portalsList.map(function(portalItem, index) {
				const portalToRemove = that.property.portalsExclusion.indexOf(portalItem[0]) !== -1;
				if(!portalToRemove) {
					that.portalsSelection.push(portalItem[0]);
				}
			});


			if (!this.property.shortDescription) {
				this.property.shortDescription = " ";
			}
			if (!this.property.longDescription) {
				this.property.longDescription = " ";
			}
			// check if brochure is being generated
			if(this.property.brochure == '...') {
				setTimeout( this.checkBrochure, 5000);
			}

      if (!this.property.livingrooms) {
        this.property.livingrooms = 0;
      }

      if (!this.property.bathrooms) {
        this.property.bathrooms = 0;
      }


      // Temporary quick&dirty fix, remove later
      if (this.property.status == 'Appraisal') {
        this.property.status = 'appraisal';
      }

			this.propertyLoaded = true;
		},
		getPropertyPortals: async function() {
			this.portalProperty = await api({endpoint: this.config.services.portals, path: '/property/' + this.$route.params.id, method: 'GET'});
		},
		latLngGenerated: function(location) {
			 this.address.latitude = location.lat();
			 this.address.longitude = location.lng();
		},
		updateProperty: async function() {
			if(this.anyErrors()) {
				alert('Please fill in the missing values in order to proceed!');
				return false;
			}

			// Address
			this.property.address.buildingNumber = this.address.buildingNumber ? this.address.buildingNumber : '';
			this.property.address.flatNumber = this.address.flatNumber ? this.address.flatNumber : '';
			this.property.address.street = (this.address && this.address.street) ? this.address.street.trim() : '';
			this.property.address.postcode = this.address.postcode ? this.address.postcode : '';
			this.property.address.town = (this.address && this.address.town) ? this.address.town.trim() : '';
			this.property.address.county = (this.address && this.address.county) ? this.address.county.trim() : '';
			this.property.address.latitude = this.address.latitude ? this.address.latitude : 0;
			this.property.address.longitude = this.address.longitude ? this.address.longitude : 0;

			// Price
			this.priceObj.price = this.priceObj.newPrice;
			this.property.price = this.priceObj.newPrice;
			this.property.rentFrequency = this.priceObj.rentFrequency;

			if(this.property.images && this.property.images.length > 0) {
				this.property.mainImage = this.property.images[0];
			} else {
				this.property.mainImage = '';
			}

			const that = this;
			this.property.features = (this.property.features && this.property.features.length) ? this.property.features.map(feature => feature.trim()).filter(function(featureItem) {
				return featureItem !== '';
			}) : [];
			this.property.shortDescription = this.property.shortDescription ? this.property.shortDescription.trim() : ' ';
			this.property.longDescription = this.property.longDescription ? this.property.longDescription.trim() : ' ';

			this.property.portalsExclusion = this.portalsList.filter(function(portalItem) {
				return that.portalsSelection.indexOf(portalItem[0]) == -1;
			}).map(function(portalItem) {
				return portalItem[0];
			});
			console.log('Exclusion:', this.property.portalsExclusion);
			var result = await api({endpoint: this.config.services.properties, path: '/' + this.$route.params.id, method: 'PUT', body: this.property});

			// check brochure progress
			this.checkBrochure();

			if(this.hasPortalsLive) {
				this.updatingPortals = true;
			}
			setTimeout(async () => {
				await this.getPropertyPortals();
				if(this.hasPortalsLive) {
					this.updatingPortals = false;
				}
			}, 5000);
		},
		updateBrochure: function() {
			this.property.baBrochure = false;
			this.updateProperty();
		},
		 showSlider: function() {
			 document.getElementById('slider-modal').style.display = "block";
		 },
		 deleteProperty: async function() {
			 if(confirm('Are you sure you want to delete this property?')) {
				 try {
					 var result = await api({endpoint: this.config.services.properties, path: '/' + this.$route.params.id, method: 'DELETE'});
					 this.$router.push('/properties');
				 } catch(err) {
					 throw {
 						type: 'delete-property',
 						error: err
 					}
				 }
			 }
		},
		archiveProperty: async function(){
			const action = this.property.archived ? 'unarchive' : 'archive';
			if(confirm(`Are you sure you want to ${action} this property?`)){
				try {
					this.property.archived = !this.property.archived;
					var result = await api({endpoint: this.config.services.properties, path: '/archive/' + this.$route.params.id, method: 'PATCH', body: {archived: this.property.archived}});
				} catch (err) {
					throw {
						type: 'archive-property',
						error: err
					}
				}
			}
		},
		errors: function(item, hasErrors) {
			this.allErrors[item] = hasErrors;
		},
		anyErrors: function() {
			var self = this;
			return Object.keys(self.allErrors).reduce(function(acc, current) {
				if(self.allErrors[current]) {
					console.log('Found error: ', current);
				}
				return acc || self.allErrors[current];
			}, false);
		},
		handleScroll: function() {
			if(window.scrollY > 0){
				this.scroll = true;
			}else{
				this.scroll = false;
			}
			},
		beforeDestroy: function() {
			window.removeEventListener('resize', this.getWindowWidth);
			window.removeEventListener('resize', this.getWindowHeight);
		},
		checkBrochure: async function() {
			const property = await api({endpoint: this.config.services.properties, path: '/' + this.$route.params.id, method: 'GET'});
			if(property.brochure != '...') {
				this.property.brochure = property.brochure;
			} else {
				this.property.brochure = '...';
				setTimeout( this.checkBrochure, 5000);
			}
		}
	}
}
// window.onclick = function(event) {
//     if (event.target == document.getElementById('slider-modal')) {
//         document.getElementById('slider-modal').style.display = "none";
//     }
// }
</script>



// WEBPACK FOOTER //
// src/pages/Properties-Edit.vue